// Styles
import './EnergyClass.scss';

// Libs
import React, { useMemo } from 'react';

import {
  EnergyClassDefaultProps,
  EnergyClassPropTypes,
} from './EnergyClass.proptypes';

const EnergyClass = ({ label, score }) => {
  const classNames = useMemo(
    () =>
      ['energy-class', `energy-class--${score.toLowerCase()}`]
        .filter((val) => val)
        .join(' '),
    [score],
  );

  return (
    <div className={classNames}>
      <span className="energy-class__score">
        <span className="score">{score}</span>
      </span>
      {label && <span className="energy-class__label">{label}</span>}
    </div>
  );
};

EnergyClass.defaultProps = {
  ...EnergyClassDefaultProps,
};

EnergyClass.propTypes = {
  ...EnergyClassPropTypes,
};

export default EnergyClass;
